<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Categoria de Contas a Receber</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Campos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 ">Codígo</th>
                    <th scope="col" class="border-0 ">Conta Contábil</th>
                    <th scope="col" class="border-0 ">Nome</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(field, index) in AccountsReceivableCategory"
                    :key="index"
                  >
                    <td></td>
                    <td>{{ field.Code }}</td>
                    <td>{{ field.AccountCode }}</td>
                    <td>{{ field.Name }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenAccountsReceivableCategory(
                                $event,
                                index,
                                true
                              )
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="
                              $isAuthorize(
                                'AccountsReceivableCategory',
                                'Update'
                              ) && !field.IsExcluded
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenAccountsReceivableCategory($event, index)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              $isAuthorize(
                                'AccountsReceivableCategory',
                                'Delete'
                              ) && !field.IsExcluded
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteAccountsReceivableCategory(
                                field.Name,
                                field.Id
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      AccountsReceivableCategory == undefined ||
                        AccountsReceivableCategory == null ||
                        AccountsReceivableCategory.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mFormAccountsReceivableCategory"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver
          tag="form"
          ref="AccountsReceivableCategoryValidationForm"
        >
          <d-form-row>
            <!-- Description -->
            <d-col v-if="pOpened != null" md="6" class="form-group">
              <label>Código</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="
                    validatedAccountsReceivableCategoryForm
                      | showValidateError(invalid)
                  "
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoAccountsReceivableCategory.Code"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAccountsReceivableCategoryForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="
                    validatedAccountsReceivableCategoryForm
                      | showValidateError(invalid)
                  "
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoAccountsReceivableCategory.Name"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAccountsReceivableCategoryForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>


          </d-form-row>

<d-form-row>
  <d-col md="12" class="form-group">
              <label>Conta Contábil</label>
              <d-form-input
                  :class="
                    validatedAccountsReceivableCategoryForm
                      | showValidateError(invalid)
                  "
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoAccountsReceivableCategory.AccountCode"
                />
            </d-col>
</d-form-row>

        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveAccountsReceivableCategory()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Nome"
            type="text"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select size="sm" v-model="filter.IsExcluded">
            <option :value="false">Ativos</option>
            <option :value="true">Inativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AccountsReceivableCategory', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo campo"
      v-b-tooltip.hover
      v-on:click="OpenAccountsReceivableCategory($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../../utils/functions.js";

export default {
  name: "AccountsReceivableCategory",
  data: function() {
    return {
      countFilter: 0,
      AccountsReceivableCategory: [],
      // AccountsReceivableCategorys: [],
      filter: {
        Name: null,
        Code: null,
        IsExcluded: false
      },
      idAccountsReceivableCategory: 0,
      infoAccountsReceivableCategory: {
        Name: null,
        AccountCode: null
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      modalTitle: "Novo Campo",
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedAccountsReceivableCategorydForm: false
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListAccountsReceivableCategory();
    },
    "pagination.RowsPerPage": function() {
      this.ListAccountsReceivableCategory();
    }
  },
  mounted() {
    this.ListAccountsReceivableCategory();
    // this.ListAccountsReceivableCategoryType();
  },
  methods: {
    OpenAccountsReceivableCategory: function(e, i, view) {
      e.preventDefault();
      this.validatedAccountsReceivableCategoryForm = false;
      this.ResetInfoAccountsReceivableCategory();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idAccountsReceivableCategory = this.AccountsReceivableCategory[
          i
        ].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Campo";
        this.GetAccountsReceivableCategory();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Novo Campo";
        this.ResetInfoAccountsReceivableCategory();
      } else {
        // View
        this.pOpened = i;
        this.idAccountsReceivableCategory = this.AccountsReceivableCategory[
          i
        ].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.GetAccountsReceivableCategory();
      }
      this.$bvModal.show("mFormAccountsReceivableCategory");
    },
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListAccountsReceivableCategory();
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Code: null,
        IsExcluded: false
      };
      this.ListAccountsReceivableCategory();
    },
    ResetInfoAccountsReceivableCategory: function() {
      this.infoAccountsReceivableCategory = {
        Name: null
      };
    },
    SaveAccountsReceivableCategory: function() {
      this.validatedAccountsReceivableCategoryForm = true;
      this.$refs.AccountsReceivableCategoryValidationForm.validate().then(
        isValid => {
          if (isValid) {
            this.loadingAddUpdate = true;
            this.isSeeing = true;

            if (this.pOpened == null) {
              this.$store
                .dispatch(
                  "AddAccountsReceivableCategory",
                  this.infoAccountsReceivableCategory
                )
                .then(() => {
                  this.$makeToast(
                    "O campo foi cadastrado com sucesso.",
                    "success",
                    "Campo cadastrado"
                  );
                  this.ListAccountsReceivableCategory();
                  this.$bvModal.hide("mFormAccountsReceivableCategory");
                })
                .catch(error => {
                  this.$makeToast(
                    "Tente novamente mais tarde.",
                    "danger",
                    "Erro ao criar campo",
                    error
                  );
                })
                .finally(() => {
                  this.loadingAddUpdate = false;
                  this.isSeeing = false;
                });
            } else {
              this.$store
                .dispatch(
                  "UpdateAccountsReceivableCategory",
                  this.infoAccountsReceivableCategory
                )
                .then(() => {
                  this.$makeToast(
                    "O Campo foi atualizado com sucesso.",
                    "success",
                    "Campo atualizado"
                  );
                  this.ListAccountsReceivableCategory();
                  this.$bvModal.hide("mFormAccountsReceivableCategory");
                })
                .catch(error => {
                  this.$makeToast(
                    "Erro ao atualizar campo, tente novamente.",
                    "danger",
                    "Erro ao atualizar campo",
                    error
                  );
                })
                .finally(() => {
                  this.loadingAddUpdate = false;
                  this.isSeeing = false;
                });
            }
          }
        }
      );
    },
    GetAccountsReceivableCategory: function() {
      if (this.idAccountsReceivableCategory != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetAccountsReceivableCategory", {
            id: this.idAccountsReceivableCategory
          })
          .then(response => {
            this.infoAccountsReceivableCategory = response;
          })
          .catch(error => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o campo",
              "danger",
              "Erro ao carregar o campo",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListAccountsReceivableCategory: function() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Nome)) this.countFilter++;
      if (hasValue(this.filter.AccountsReceivableCategory)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.IsExcluded": this.filter.IsExcluded
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAccountsReceivableCategory", { params: data })
        .then(response => {
          this.AccountsReceivableCategory = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },

    ConfirmDeleteAccountsReceivableCategory: function(Nome, id) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + Nome + " ?",
        "Confirmar",
        this.DeleteAccountsReceivableCategory,
        id
      );
    },
    DeleteAccountsReceivableCategory: function(id) {
      this.$store
        .dispatch("DeleteAccountsReceivableCategory", { id: id })
        .then(() => {
          this.$makeToast(
            "O Campo foi removido com sucesso.",
            "success",
            "Campo removido"
          );
          this.ListAccountsReceivableCategory();
          this.$bvModal.hide("mFormAccountsReceivableCategory");
        })
        .catch(error => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao remover Campo",
            error
          );
        });
    },
    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/AccountsReceivable/AccountsReceivableCategory.vue